import {type PIXI} from '@colonist/pixi'

export class UIGameOpacityAnimation {
    private decreaseOpacity: boolean

    constructor() {
        this.decreaseOpacity = false
    }

    animateOpacity(viewToAnimateOpacity: PIXI.Container) {
        const alphaDifferencePerTick = 0.006
        const minimumOpacity = 0.6
        if(this.decreaseOpacity) viewToAnimateOpacity.alpha = viewToAnimateOpacity.alpha - alphaDifferencePerTick
        else viewToAnimateOpacity.alpha = viewToAnimateOpacity.alpha + alphaDifferencePerTick
        if(viewToAnimateOpacity.alpha >= 1) this.decreaseOpacity = true
        if(viewToAnimateOpacity.alpha <= minimumOpacity) this.decreaseOpacity = false
    }
}
